import cx from "classnames";
import { AlertErrorIconSvg } from "components/icons/Alert/AlertErrorIconSvg";
import { AlertInfoIconSvg } from "components/icons/Alert/AlertInfoIconSvg";
import { AlertSuccessIconSvg } from "components/icons/Alert/AlertSuccessIconSvg";
import { AlertWarningIconSvg } from "components/icons/Alert/AlertWarningIconSvg";
import { FC, ReactNode } from "react";
import st from "./Notification.module.scss";

export type NotificationType = "info" | "error" | "warning" | "success";

type NotificationProps = {
  type: NotificationType;
  fullWidth?: boolean;
  title: ReactNode;
  subText?: ReactNode;
  hideBackground?: boolean;
  hasIcon?: boolean;
};

export const Notification: FC<NotificationProps> = ({
  type,
  fullWidth,
  title,
  subText,
  hasIcon = true,
}) => {
  return (
    <div
      className={cx(
        st.notification,
        fullWidth && st.fullWidth,
        type === "info" && st.info,
      )}
    >
      {hasIcon && <NotificationIcon type={type} />}
      <div className={st.textContainer}>
        <div className={st.title}>{title}</div>
        <div className={st.subText}>{subText}</div>
      </div>
    </div>
  );
};

const NotificationIcon: FC<{ type: NotificationType }> = ({ type }) => {
  switch (type) {
    case "success":
      return <AlertSuccessIconSvg />;
    case "error":
      return <AlertErrorIconSvg />;
    case "warning":
      return <AlertWarningIconSvg />;
    case "info":
      return <AlertInfoIconSvg />;
    default:
      return null;
  }
};
